export default __webpack_public_path__ + "static/dkb-3daf440c001d424dc57022e2285c1de3.svg";